import { siteNames } from '@seek/melways-sites';

import type { EmployerSiteName } from 'src/types/app';

export const hasOtherLanguageAIButton = (site: EmployerSiteName): boolean => {
  const sitesHaveOtherLanguage: EmployerSiteName[] = [
    siteNames.employer.seek.hk,
    siteNames.employer.seek.id,
    siteNames.employer.seek.th,
  ];

  return sitesHaveOtherLanguage.includes(site);
};
